<template>
    <div>
        <section id="buttonSection"
            class="relative flex flex-col md:flex-row text-center justify-center container mx-auto px-4 md:px-0">
            <div
                class="home-description flex md:absolute bg-yellow-photo z-10 px-4 md:px-8 py-4 my-8 md:my-0 items-center md:-top-60 rounded">
                <div>
                    <img src="https://photo-public.s3.amazonaws.com/suf/home/photo-pass-logo.png" alt="logo parque"
                        class="w-full md:w-auto md:h-32" />
                </div>

                <div class="flex flex-col text-left max-w-132 ml-4">
                    <h3 class="uppercase font-bold text-2xl mb-4">
                        {{ $t("Forms.slogan") }}
                    </h3>

                    <!-- <p class="mb-4">
                        Lorem ipsum dolor sit amet consectetur adipiscing elit
                        felis scelerisque, eu sociosqu leo himenaeos etiam metus
                        nostra aliquam in, morbi laoreet euismod magna venenatis
                        et fringilla aptent
                    </p> -->

                    <p>
                        <strong>{{ $t("Forms.imp") }}</strong>
                        {{ $t("Forms.info") }}
                        <br>
                        {{ $t("Forms.tel_mx") }}
                        <br>
                        {{ $t("Forms.tel_foreign") }}
                    </p>
                </div>
            </div>

            <button @click.prevent="chooseOption(1)" type="button"
                class="flex justify-center items-center rounded-full py-4 px-4 mx-2 my-2 border border-yellow-photo cursor-pointer font-semibold"
                :class="option == 2 ? 'bg-yellow-photo' : 'bg-white'">
                <!-- <font-awesome-icon
            class="mx-1 pointer-events-none"
            :icon="['fas', 'images']"
          /> -->
                {{ $t("Forms.i_have_download_code") }}
            </button>

            <button @click.prevent="chooseOption(2)" type="button"
                class="flex justify-center items-center rounded-full py-4 px-4 mx-2 my-2 border border-yellow-photo cursor-pointer font-semibold"
                :class="option == 1 ? 'bg-yellow-photo' : 'bg-white'">
                {{ $t("Forms.buy_photos") }}
            </button>
        </section>

        <formParkHotel dc="false" v-if="option == 1" />
        <formDownloadCode v-if="option == 2" />
    </div>
</template>

<script>
import "../validators/index";

import methodUser from "../mixins/methodUser";
import Multimedia from "../mixins/Multimedia";

import formParkHotel from "../forms/AddParkHotel.vue";
import formDownloadCode from "../forms/AddDownloadCode.vue";

export default {
    props: ["redirect"],
    mixins: [methodUser, Multimedia],
    components: {
        formParkHotel,
        formDownloadCode,
    },
    data: () => ({
        firstName: "",
        lastName: "",
        email: "",
        errors: [],
        downloadCodes: [],
        option: 2,
        loading: false,
        screenLoading: false,
        lastInsertItem: [],
        GetPhotos: {
            question: "",
            JoinedCode: "",
            ParkID: null,
            visitDate: "",
            tag: "",
            HotelID: null,
            Room: "",
            ArrivalDate: "",
            DepartureDate: "",
        },
        Parks: [{ value: null, text: "Seleccione una opción" }],
        Hotels: [{ value: null, text: "Seleccione una opción" }],
    }),
    computed: {
        GetParks() {
            return this.$store.getters.GetParks;
        },
    },
    methods: {
        chooseOption(option) {
            //Park | Hotel
            if (option == 1) {
                this.option = 2;
                this.GetPhotos.question = "";
            } 
            //Download Code
            if (option == 2) {
                this.option = 1;
                this.GetPhotos.question = 3;
            }
        },
    },
    created() {},
    mounted() {
        if (!this.$store.getters.GetParks.length) {
            this.getAllParks();
        }
    },
};
</script>
